import { useState } from "react";
import * as Yup from "yup";
import { useFormik } from "formik";
import { selector } from "../../../api";
import { Divider, Input, notification } from "antd";
import { formComponent } from "../../../utils";
import { configurationCRUD } from "../../../actions/configuration";
import { Modal } from "rsuite";

const currencySchema = Yup.object().shape({
  code: Yup.string().required("This field is required"),
  name: Yup.string().required("This field is required"),
});

const initialValues = {
  code: "",
  name: "",
};

export const CurrencyAdd = (props) => {
  const { open, setOpen, index, setIndex } = props;
  const user = selector.User();
  const [api, contextHolder] = notification.useNotification();
  const [loading, setLoading] = useState(false);

  const formik = useFormik({
    initialValues,
    validationSchema: currencySchema,
    onSubmit: (values, { setSubmitting, resetForm }) => {
      const { code, name } = values;
      const data = {
        code,
        name,
        created_by: user.id,
        created_by_name:
          user?.first_name + " " + user?.middle_name + " " + user?.last_name,
      };
      setLoading(true);
      setTimeout(() => {
        configurationCRUD
          .adCurrency([data])
          .then(() => {
            api.success({
              message: "Thank you",
              description:
                "🎉 Congratulations! Your data has been successfully saved!",
              placement: "topRight",
            });
            setIndex(index + 1);
            resetForm();
            setLoading(false);
            setSubmitting(false);
            setOpen(false);
          })
          .catch((error) => {
            setLoading(false);
            setSubmitting(false);
            api.error({
              message: error.message,
              description:
                "Oops! It looks like there is some errors. Please correct your error and try again",
              placement: "topRight",
            });
          });
      }, 2000);
    },
  });

  return (
    <>
      {contextHolder}
      <Modal open={open} onClose={() => setOpen(false)} size="md">
        <Modal.Header>
          <Modal.Title>New Currency</Modal.Title>
        </Modal.Header>
        <Divider />
        <form onSubmit={formik.handleSubmit}>
          <Modal.Body>
            <div className="container">
              <div className="row">
                <div className="col-md-6 col-sm-12">
                  <div className="form-group">
                    <label className="form-label">
                      Currency Code <span className="text-danger">*</span>
                    </label>
                    <Input
                      {...formik.getFieldProps("code")}
                      className="form-control"
                      placeholder="Currency Code"
                      size="large"
                      status={
                        formik.touched.code && formik.errors.code && "error"
                      }
                    />
                    {formik.touched.code && formik.errors.code && (
                      <div
                        className="fw-light mt-1"
                        style={{ fontSize: "14px" }}
                      >
                        <span role="alert" className="text-danger">
                          {formik.errors.code}
                        </span>
                      </div>
                    )}
                  </div>
                </div>
                <div className="col-md-6 col-sm-12">
                  <label className="form-label">
                    Currency Name <span className="text-danger">*</span>
                  </label>
                  <Input
                    {...formik.getFieldProps("name")}
                    placeholder="Currency Name"
                    className="form-control"
                    size="large"
                    status={
                      formik.touched.name && formik.errors.name && "error"
                    }
                  />
                  {formik.touched.name && formik.errors.name && (
                    <div className="fw-light mt-1" style={{ fontSize: "14px" }}>
                      <span role="alert" className="text-danger">
                        {formik.errors.name}
                      </span>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </Modal.Body>
          <Divider style={{ marginTop: -10 }} />
          <Modal.Footer>
            <div className="container">
              <div className="row">
                <div className="col-md-6 col-sm-12 d-flex justify-content-start">
                  <span className="fs-18 text-danger"> * &nbsp;</span> Required
                  field
                </div>
                <div className="col-md-6 col-sm-12 d-flex justify-content-end">
                  <button
                    onClick={() => setOpen(false)}
                    type="button"
                    className="btn btn-soft-danger btn-label waves-effect waves-light rounded-pill me-3"
                  >
                    <i class="ri-close-circle-line label-icon align-middle rounded-pill fs-16 me-2"></i>{" "}
                    Cancel
                  </button>
                  <button
                    type="submit"
                    className="btn btn-soft-success btn-label waves-effect waves-light rounded-pill"
                    disabled={formik.isSubmitting}
                  >
                    {!loading && (
                      <span className="indicator-label">
                        <i class="ri-check-double-line label-icon align-middle rounded-pill fs-16 me-2"></i>{" "}
                        Save
                      </span>
                    )}
                    {loading && (
                      <span
                        className="indicator-progress"
                        style={{ display: "block" }}
                      >
                        Please wait...
                        <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
                      </span>
                    )}
                  </button>
                </div>
              </div>
            </div>
          </Modal.Footer>
        </form>
      </Modal>
    </>
  );
};
